/**
 * @generated SignedSource<<f0a18871e402fa1e2a8562cf6fc0516f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedMarketTrendsTopSales_creatorMarketTrends$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly dateSold: string | null;
      readonly itemId: string | null;
      readonly itemThumbnail: string | null;
      readonly itemTitle: string | null;
      readonly pdpUrl: string | null;
      readonly rank: number;
      readonly salePrice: {
        readonly " $fragmentSpreads": FragmentRefs<"currencyHelpers_financialAmount">;
      } | null;
    } | null;
  } | null> | null;
  readonly priceStats: {
    readonly __typename: "MarketTrendsPriceStats";
  } | null;
  readonly " $fragmentType": "SbSharedMarketTrendsTopSales_creatorMarketTrends";
};
export type SbSharedMarketTrendsTopSales_creatorMarketTrends$key = {
  readonly " $data"?: SbSharedMarketTrendsTopSales_creatorMarketTrends$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedMarketTrendsTopSales_creatorMarketTrends">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedMarketTrendsTopSales_creatorMarketTrends",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MarketTrendsPriceStats",
      "kind": "LinkedField",
      "name": "priceStats",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MarketTrendsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MarketTrendsTopSales",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rank",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "itemId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "itemTitle",
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "size",
                  "value": "thumb"
                }
              ],
              "kind": "ScalarField",
              "name": "itemThumbnail",
              "storageKey": "itemThumbnail(size:\"thumb\")"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pdpUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "salePrice",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "currencyHelpers_financialAmount",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ConvertedAmountList",
                      "kind": "LinkedField",
                      "name": "convertedAmountList",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "amount",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currency",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "args": null,
                  "argumentDefinitions": []
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "dateSold",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MarketTrendsConnection",
  "abstractKey": null
};

(node as any).hash = "91d0b46b910f20d2ca4826e8c4201170";

export default node;
